/** Normaliza URLs de TikTok / Instagram a src seguros para iframe embed. */

function safeHost(hostname) {
  const h = (hostname || "").toLowerCase();
  return h === "www.tiktok.com" || h === "tiktok.com" || h === "www.instagram.com" || h === "instagram.com";
}

const IG_PATH_RESERVED = new Set([
  "p",
  "reel",
  "reels",
  "tv",
  "explore",
  "stories",
  "accounts",
  "direct",
  "legal",
  "about",
  "developer",
  "static",
]);

/**
 * @param {string} raw
 * @returns {string} URL del reproductor o cadena vacía
 */
export function tiktokEmbedSrc(raw) {
  const t = (raw || "").trim();
  if (!t) return "";
  try {
    const u = new URL(t.includes("http") ? t : `https://${t}`);
    if (!safeHost(u.hostname)) return "";
    const m = u.pathname.match(/\/video\/(\d+)/);
    if (m) return `https://www.tiktok.com/embed/v2/${m[1]}`;
    const m2 = u.pathname.match(/\/embed\/v2\/(\d+)/);
    if (m2) return `https://www.tiktok.com/embed/v2/${m2[1]}`;
  } catch (_) {
    /* noop */
  }
  return "";
}

/** URL de perfil/creador (sin /video/) — requiere oEmbed + script embed.js en el cliente. */
export function tiktokNeedsCreatorOembed(raw) {
  const t = (raw || "").trim();
  if (!t) return false;
  if (tiktokEmbedSrc(t)) return false;
  try {
    const u = new URL(t.includes("http") ? t : `https://${t}`);
    if (!safeHost(u.hostname)) return false;
    const path = u.pathname.replace(/\/+$/, "") || "/";
    if (/\/video\/\d+/.test(path)) return false;
    return /^\/@[^/]+\/?$/i.test(path);
  } catch (_) {
    return false;
  }
}

/**
 * Convierte URL de Instagram (post, reel, reels, tv)
 * en URL de iframe /embed oficial.
 * Perfiles no se soportan como embed (Instagram no lo permite y redirige con utm_campaign=invalid).
 * @see https://developers.facebook.com/docs/instagram-platform/oembed (posts / reels)
 */
export function instagramEmbedSrc(raw) {
  const t = (raw || "").trim();
  if (!t) return "";
  try {
    const u = new URL(t.includes("http") ? t : `https://${t}`);
    if (!safeHost(u.hostname)) return "";
    const path = (u.pathname || "/").replace(/\/+$/, "") || "/";

    const mShort = path.match(/^\/(p|reel|reels|tv)\/([^/?#]+)\/?$/i);
    if (mShort) {
      const kind = mShort[1].toLowerCase() === "reels" ? "reel" : mShort[1].toLowerCase();
      const code = mShort[2];
      return `https://www.instagram.com/${kind}/${encodeURIComponent(code)}/embed`;
    }

    const mUserPost = path.match(/^\/([^/?#]+)\/(p|reel|reels|tv)\/([^/?#]+)\/?$/i);
    if (mUserPost) {
      const first = mUserPost[1].toLowerCase();
      if (!IG_PATH_RESERVED.has(first)) {
        const kind = mUserPost[2].toLowerCase() === "reels" ? "reel" : mUserPost[2].toLowerCase();
        const code = mUserPost[3];
        return `https://www.instagram.com/${kind}/${encodeURIComponent(code)}/embed`;
      }
    }

    // Los perfiles (instagram.com/usuario/) no tienen embed válido en Instagram.
    // No generamos ninguna URL — se mostrará el mensaje de fallback.
  } catch (_) {
    /* noop */
  }
  return "";
}

export function embedSrcForWidget(type, text) {
  if (type === "embed_tiktok") return tiktokEmbedSrc(text);
  if (type === "embed_instagram") return instagramEmbedSrc(text);
  return "";
}
